import React from "react";
import marked from "marked";
import styles from "./Body.scss";

const Body = props => {
  const { content, className = "" } = props;

  return (
    <div
      className={`news__article-body ${styles.message} ${className}`}
      dangerouslySetInnerHTML={{ __html: marked(content) }}
    />
  );
};

export default Body;
